/* @ngInject */
const myLoading = () => {
  return {
    restrict: 'E',
    scope: {

    },
    template: require('./myLoading.html'),

    /* @ngInject */
    controller: ($scope) => {

    },
    link: (scope, element, attrs, ctrl) => {

    },
  }
}

export default myLoading



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/directives/loading/myLoading.js